import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { toastService } from "../../services/toastService";

export const getInvoiceData = createAsyncThunk(
  "invoice/getInvoice",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/v1/Receivables/Invoices?contact_ID=${id}`
      );
      const data = response?.data;
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error getting invoive data"
      );
    }
  }
);

export const getAddFeesDropDown = createAsyncThunk(
  "invoice/getAddFeesDropDown",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/v1/settings/GetAddFeesDropDown`
      );
      const data = response?.data;
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error getting add fees data"
      );
    }
  }
);

export const getCreditCardEquipmentData = createAsyncThunk(
  "invoice/getCreditCardEquipmentData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "/v1/Account/GetCreditCardEquipment"
      );
      const data = response?.data;
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error getting card eqiupment data"
      );
    }
  }
);

export const getApplyPaymentInvoices = createAsyncThunk(
  "invoice/getApplyPaymentInvoices",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `v1/account/GetInvoices?Account_ID=${id}`
      );
      const data = response?.data;
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error getting invoive data"
      );
    }
  }
);

export const getApplyPaymentSettlements = createAsyncThunk(
  "invoice/getApplyPaymentSettlements",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `v1/Account/GetSettlements?Account_ID=${id}`
      );
      const data = response?.data;
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error getting invoive data"
      );
    }
  }
);

export const getSurcharge = async (params) => {
  try {
    const response = await axiosInstance.get(
      `v1/Payment/GetSurcharge?Amount=${params.amount}&Terminal_ID=${params.terminal_ID}`
    );
    const data = response?.data?.surcharge;
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const getTransactionHistory = async (params) => {
  try {
    const response = await axiosInstance.get(
      `v1/account/GetTransactionHistory?Account_ID=${params.accountId}`
    );
    const data = response?.data?.surcharge;
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const applyPayment = createAsyncThunk(
  "invoice/applyPayment",
  async ({ payload, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `v1/account/ApplyPayment`,
        payload
      );
      const data = response?.data;
      toastService.success("Payment applied successfully");
      onSuccess();
      return data;
    } catch (err) {
      toastService.error(err);
      return rejectWithValue(
        err.response?.data?.message || "Error apply payment"
      );
    }
  }
);

export const sendEmailInvoice = createAsyncThunk(
  "invoice/sendEmailInvoice",
  async ({ payload, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/v1/Account/EmailInvoice`,
        payload
      );
      const data = response?.data;
      onSuccess?.(data);
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error creating invoice"
      );
    }
  }
);

export const applySettlementPayment = createAsyncThunk(
  "invoice/applySettlementPayment",
  async ({ payload, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `v1/account/ApplySettlementPayment`,
        payload
      );
      const data = response?.data;
      toastService.success("Payment applied successfully");
      onSuccess();
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error apply settlement payment"
      );
    }
  }
);

export const editInvoice = createAsyncThunk(
  "invoice/editInvoice",
  async ({ payload, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/v1/Package/BuyerStatementUpdateLineItem`,
        payload
      );
      if (response.status >= 400) {
        throw new Error(response.data)
      };
      const data = response?.data;
      onSuccess?.(data);
      return data;
    } catch (err) {
      return rejectWithValue(err?.message || "Error editing invoice");
    }
  }
);

export const deleteInvoice = createAsyncThunk(
  "invoice/deleteInvoice",
  async ({ payload, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/v1/package/RemoveItemFromInvoice`,
        payload
      );
      if (response.status >= 400) throw new Error(response.data);
      const data = response?.data;
      onSuccess?.(data);
      return data;
    } catch (err) {
      return rejectWithValue(err?.message || "Error deleting invoice");
    }
  }
);


export const bulkEditInvoices = createAsyncThunk(
  "invoice/bulkEditInvoices",
  async ({ payloads, onSuccess }, { rejectWithValue }) => {
    const results = {
      success: [],
      failed: [],
    };

    for (const payload of payloads) {
      try {
        const response = await axiosInstance.post(
          `/v1/Package/BuyerStatementUpdateLineItem`,
          payload
        );
        const data = response?.data;
        if (response.status >= 400) {
          throw new Error(response.data)
        };
        results.success.push(data);
      } catch (err) {
        results.failed.push({
          payload,
          error: err?.response?.data || err?.message || "Unknown error",
        });
      }
    }

    onSuccess?.(results.success);

    // If there are any failures, reject with the failed array
    if (results.failed.length > 0) {
      return rejectWithValue(results.failed);
    }

    return results;
  }
);

// export const getSubInvoice = createAsyncThunk(
//   "invoice/getSubInvoice",
//   async ({id, name}, { rejectWithValue }) => {
//     try {
//       const response = await axiosInstance.get(
//         `/v1/account/GetInvoices?Account_ID=${id}`
//       );
//       const data = {[id]: {
//         name,
//         data: response?.data,
//       }};
//       return data;
//     } catch (err) {
//       return rejectWithValue(
//         err.response?.data?.message || "Error getting invoive data"
//       );
//     }
//   }
// );

export const addItemBuyerFee = createAsyncThunk(
  "invoice/addItemBuyerFee",
  async ({ payload, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `v1/Package/BuyerStatementAddFee`,
        payload
      );
      const data = response?.data;
      onSuccess(data);
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error add item buyer"
      );
    }
  }
);

export const updateBulkItemTaxable = createAsyncThunk(
  "invoice/updateBulkItemTaxable",
  async ({ payload, onSuccess, onError }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/v1/Package/BuyerStatementUpdateLineItems`,
        payload
      );
      if (response.status >= 400) {
        throw new Error(response.data)
      };
      const data = response?.data;
      onSuccess?.(data);
      return data;
    } catch (err) {
      onError?.(err?.message || "Error updating bulk item taxable", !!err.response);
      return rejectWithValue(err?.message || "Error updating bulk item taxable");
    }
  }
);

const InvoiceSlice = createSlice({
  name: "invoice",
  initialState: {
    data: [],
    loading: false,
    error: null,
    creditCardEquipments: [],

    applyPaymentInvoices: {},
    applyPaymentInvoicesLoading: false,

    applyPaymentSettlements: {},
    applyPaymentSettlementsLoading: false,

    applyPaymentLoading: false,
    applySettlementPaymentLoading: false,

    emailData: null,
    emailLoading: false,
    emailError: null,

    editInvoiceData: null,
    editInvoiceLoading: false,
    editInvoiceError: null,

    deleteInvoiceData: null,
    deleteInvoiceLoading: false,
    deleteInvoiceError: null,

    getSubInvoiceData: [],
    getSubInvoiceLoading: false,
    getSubInvoiceError: null,

    bulkEditInvoiceData: [],
    bulkEditInvoiceLoading: false,
    bulkEditInvoiceError: null,

    getAddFeesDropDownData: [],
    getAddFeesDropDownLoading: false,
    getAddFeesDropDownError: null,

    addItemBuyerFeeData: null,
    addItemBuyerFeeLoading: false,
    addItemBuyerFeeError: null,

    updateBulkItemTaxableData: [],
    updateBulkItemTaxableLoading: false,
    updateBulkItemTaxableError: null,
  },
  reducers: {
    clearErrors: (state) => {
      state.bulkEditInvoiceError = null;
      state.editInvoiceError = null;
      state.deleteInvoiceError = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvoiceData.pending, (state) => {
        // state.getSubInvoiceData = [];
        state.loading = true;
        // state.data = [];
      })
      .addCase(getInvoiceData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(getInvoiceData.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(getCreditCardEquipmentData.fulfilled, (state, action) => {
        state.creditCardEquipments = action.payload;
      })

      .addCase(getApplyPaymentInvoices.pending, (state) => {
        state.applyPaymentInvoicesLoading = true;
      })
      .addCase(getApplyPaymentInvoices.fulfilled, (state, action) => {
        state.applyPaymentInvoices = action.payload;
        state.applyPaymentInvoicesLoading = false;
      })
      .addCase(getApplyPaymentInvoices.rejected, (state) => {
        state.applyPaymentInvoicesLoading = false;
      })

      .addCase(getApplyPaymentSettlements.pending, (state) => {
        state.applyPaymentSettlementsLoading = true;
      })
      .addCase(getApplyPaymentSettlements.fulfilled, (state, action) => {
        state.applyPaymentSettlements = action.payload;
        state.applyPaymentSettlementsLoading = false;
      })
      .addCase(getApplyPaymentSettlements.rejected, (state) => {
        state.applyPaymentSettlementsLoading = false;
      })

      .addCase(applyPayment.pending, (state) => {
        state.applyPaymentLoading = true;
      })
      .addCase(applyPayment.fulfilled, (state) => {
        state.applyPaymentLoading = false;
      })
      .addCase(applyPayment.rejected, (state, action) => {
        toastService.error(action.payload);
        state.applyPaymentLoading = false;
      })

      .addCase(applySettlementPayment.pending, (state) => {
        state.applySettlementPaymentLoading = true;
      })
      .addCase(applySettlementPayment.fulfilled, (state) => {
        state.applySettlementPaymentLoading = false;
      })
      .addCase(applySettlementPayment.rejected, (state) => {
        state.applySettlementPaymentLoading = false;
      })

      .addCase(sendEmailInvoice.pending, (state) => {
        state.emailLoading = true;
      })
      .addCase(sendEmailInvoice.fulfilled, (state, action) => {
        state.emailData = action.payload;
        state.emailLoading = false;
      })
      .addCase(sendEmailInvoice.rejected, (state, action) => {
        state.emailError = action.payload;
        state.emailLoading = false;
      })

      .addCase(editInvoice.pending, (state) => {
        state.editInvoiceLoading = true;
      })
      .addCase(editInvoice.fulfilled, (state, action) => {
        state.editInvoiceData = action.payload;
        state.editInvoiceLoading = false;
      })
      .addCase(editInvoice.rejected, (state, action) => {
        // state.editInvoiceError = [...state.editInvoiceError,action.payload];
        state.editInvoiceError = action.payload;
        state.editInvoiceLoading = false;
      })

      .addCase(deleteInvoice.pending, (state) => {
        state.deleteInvoiceError = null;
        state.deleteInvoiceLoading = true;
      })
      .addCase(deleteInvoice.fulfilled, (state, action) => {
        state.deleteInvoiceError = null;
        state.deleteInvoiceData = action.payload;
        state.deleteInvoiceLoading = false;
      })
      .addCase(deleteInvoice.rejected, (state, action) => {
        state.deleteInvoiceError = action.payload;
        state.deleteInvoiceLoading = false;
      })

      .addCase(bulkEditInvoices.pending, (state) => {
        state.bulkEditInvoiceLoading = true;
      })
      .addCase(bulkEditInvoices.fulfilled, (state, action) => {
        state.bulkEditInvoiceLoading = false;
        state.bulkEditInvoiceData = action.payload;
      })
      .addCase(bulkEditInvoices.rejected, (state, action) => {
        state.bulkEditInvoiceLoading = false;
        state.bulkEditInvoiceError = action.payload;
      })

      .addCase(getAddFeesDropDown.pending, (state) => {
        state.getAddFeesDropDownLoading = true;
      })
      .addCase(getAddFeesDropDown.fulfilled, (state, action) => {
        state.getAddFeesDropDownLoading = false;
        state.getAddFeesDropDownData = action.payload;
      })
      .addCase(getAddFeesDropDown.rejected, (state, action) => {
        state.getAddFeesDropDownLoading = false;
        state.getAddFeesDropDownError = action.payload;
      })

      .addCase(addItemBuyerFee.pending, (state) => {
        state.addItemBuyerFeeLoading = true;
      })
      .addCase(addItemBuyerFee.fulfilled, (state, action) => {
        state.addItemBuyerFeeLoading = false;
        state.addItemBuyerFeeData = action.payload;
      })
      .addCase(addItemBuyerFee.rejected, (state, action) => {
        state.addItemBuyerFeeLoading = false;
        state.addItemBuyerFeeError = action.payload;
      })

      .addCase(updateBulkItemTaxable.pending, (state) => {
        state.updateBulkItemTaxableLoading = true;
      })

      .addCase(updateBulkItemTaxable.fulfilled, (state, action) => {
        state.updateBulkItemTaxableLoading = false;
        state.updateBulkItemTaxableData = action.payload;
      })

      .addCase(updateBulkItemTaxable.rejected, (state, action) => {
        state.updateBulkItemTaxableLoading = false;
        state.updateBulkItemTaxableError = action.payload;
      })

    // .addCase(getSubInvoice.pending, (state) => {
    //   state.getSubInvoiceData = [];
    //   state.getSubInvoiceError = null;
    //   state.getSubInvoiceLoading = true;
    // })
    // .addCase(getSubInvoice.fulfilled, (state, action) => {
    //   state.getSubInvoiceError = null;
    //   state.getSubInvoiceData = [...state.getSubInvoiceData, action.payload];
    //   state.getSubInvoiceLoading = false;
    // })
    // .addCase(getSubInvoice.rejected, (state, action) => {
    //   state.getSubInvoiceError = action.payload;
    //   state.getSubInvoiceLoading = false;
    // });
  },
});

export default InvoiceSlice.reducer;
